import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-300/40'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="w-9 h-9 flex items-center justify-center">
            <i className="ri-fire-fill text-2xl text-primary-500"></i>
          </span>
          <span className="font-heading text-xl font-bold text-foreground-50 tracking-wide">
            91<span className="text-primary-500">黑料</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              location.pathname === '/'
                ? 'text-primary-500 bg-primary-500/10'
                : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50'
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 5).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === `/category/${cat.slug}`
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        {/* Desktop actions */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              location.pathname === '/about'
                ? 'text-accent-500 bg-accent-500/10'
                : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50'
            }`}
          >
            关于我们
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-300 hover:text-foreground-100 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        } bg-background-100/95 backdrop-blur-md border-b border-background-300/40`}
      >
        <div className="px-4 py-3 flex flex-col gap-1">
          <Link
            to="/"
            className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50 transition-colors cursor-pointer"
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50 transition-colors cursor-pointer"
          >
            关于我们
          </Link>
        </div>
      </div>
    </header>
  );
}